<template>
  <div id="app">
  <div class="contGeneral" :style="'background-image:url(' + $store.getters.imagen + ');'" :class="{'mideMenos' : $store.getters.mideMenos, 'mideMas': $store.getters.mideMas}">
      <div class="cierraMenu" v-if="flotante" @click="ocultaMenu"></div>
      <header>
            <nav class="navbar navbar-expand-lg navbar-dark">
                <router-link class="navbar-brand ml-lg-5" to="/">
                    <img src="@/assets/images/logo-RMZ-Asesores-blanco.svg" width="210" height="60" v-if="logobco">
                    <img src="@/assets/images/logoazul.svg" width="210" height="60" v-else>
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon" v-if="muestraMenu"></span>
                    <span class="navbar-toggler-icon2" v-else></span>
                </button>
                <div class="collapse navbar-collapse justify-content-end mx-5" id="navbarCollapse">
                    <ul class="navbar-nav">
                        <li class="nav-item active">
                            <router-link to="/nosotros" class="nav-link cierra" data-toggle="collapse" data-target=".navbar-collapse.show">Nosotros</router-link>
                        </li>
                        <li class="nav-item dropdown">
                            <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Nuestros servicios</a>
                            <div class="dropdown-menu">
                                <router-link to="/seguros-venta-y-asesoria-individuos" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">Seguros: venta y asesoría</router-link>
                                <router-link to="/administracion-de-riesgos" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">Administración de riesgos</router-link>
                                <router-link to="/auditoria-en-seguros" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">Auditoría en seguros</router-link>
                                <router-link to="/asesoria-en-siniestros" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">Asesoría en siniestros</router-link>
                            </div>
                        </li>
                        <li class="nav-item">
                            <a href="https://blog.rmzasesores.com" class="nav-link cierra">Blog</a>
                        </li>
                        <li class="nav-item">
                            <a href="#" v-scroll-to="$store.getters.ira" class="nav-link cierra" data-toggle="collapse" data-target=".navbar-collapse.show">Contacto</a>
                        </li>
                    </ul>
                    <div class="d-block d-lg-none azulTel">
                      <div class="row justify-content-center">
                          <div class="col-12 text-center">
                              <hr>
                              <h2>Hablemos</h2>
                          </div>
                      </div>
                      <div class="row justify-content-center">
                          <div class="col-lg-4 text-center">
                              <div class="tel align-middle mx-auto"><a href="tel:+523335633993">+52 333563-3993</a></div>
                          </div>
                      </div>
                  </div>
                </div>
                <div id="tel" class="mr-5 d-none d-xl-block"><a href="tel:+523335633993">Tel.: 333563-3993</a></div>
            </nav>
        </header>
        <div class="barraGris" style="display: none;">
        </div>
  </div>
        <div class="scrollDown"><img src="@/assets/images/header-icono-scrolldown.svg" /></div>
        <main role="main" class="flex-shrink-0">
          <div class="container-fluid p-0" :class="{'estira': $store.getters.estira}">
            <router-view/>
          </div>
        </main>
      <section class="comunicacion" id="contacto" v-if="$store.getters.footer != 'oculta'">
          <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <hr>
                    <h2>Hablemos</h2>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-4 text-center">
                    <img src="@/assets/images/contacto-icono-tel.svg" width="40" height="40">
                    <div class="comunicacion-titulo p-3 my-3">Por teléfono:</div>
                    <div class="tel align-middle mx-auto"><a href="tel:+523335633993">+52 333563-3993</a></div>
                </div>
                <div class="col-lg-4 text-center mt-5 mt-lg-0">
                    <img src="@/assets/images/contacto-icono-whatsapp.svg" width="40" height="40">
                    <div class="comunicacion-titulo bordes p-3 my-3">Por WhatsApp:</div>
                    <div class="tel align-middle mx-auto">
                        <a href="https://wa.me/523310735383?text=Web rmzasesores.com: " class="d-block d-md-none">+52 331073-5383</a>
                        <a href="https://web.whatsapp.com/send?phone=523310735383?text=Web rmzasesores.com: " class="d-none d-md-block">+52 331073-5383</a>
                    </div>
                </div>
                <div class="col-lg-4 text-center mt-5 mt-lg-0">
                    <img src="@/assets/images/contacto-icono-email.svg" width="40" height="40">
                    <div class="comunicacion-titulo p-3 my-3">Por correo:</div>
                    <div class="email align-middle mx-auto"><a href="mailto:info@rmzasesores.com">info@rmzasesores.com</a></div>
                </div>
            </div>
        </div>
        <img class="fondo" src="@/assets/images/body-background-textura04.svg" />
        <img class="fondo2" src="@/assets/images/body-background-textura01.svg" />
      </section>
      <section class="siguenos" v-if="$store.getters.footer != 'oculta'">
          <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6 bloque-azul text-center">
                    <h3>Síguenos en nuestras redes sociales:</h3>
                    <a href="https://www.facebook.com/AdministracionIntegraldeRiesgos" target="_blank"><img src="@/assets/images/redes-icono-facebook.svg" /></a>
                    <a href="https://www.instagram.com/rmz_asesores/" target="_blank"><img src="@/assets/images/redes-icono-instagram.svg" /></a>
                    <a href="https://www.linkedin.com/in/rmz-asesores-2159491a/" target="_blank"><img src="@/assets/images/redes-icono-linkedin.svg" /></a>
                </div>
            </div>
          </div>
      </section>
    <footer class="footer mt-auto py-5">
      <div class="container" :class="{'separa': $store.getters.footer == 'muestra'}">
        <div class="row justify-content-center">
            <div class="col-lg-3 text-center text-lg-left mt-5 m-md-0">
                <h3>NOSOTROS</h3>
                <hr>
                <router-link to="/nosotros" class="footer-link">Somos RMZ Asesores</router-link>
            </div>
            <div class="col-lg-3 text-center text-lg-left mt-5 m-md-0">
                <h3>NUESTROS SERVICIOS</h3>
                <hr>
                <router-link to="/seguros-venta-y-asesoria-individuos" class="footer-link">Para individuos y familias</router-link>
                <router-link to="/seguros-venta-y-asesoria-profesionales" class="footer-link">Para profesionistas ind. y Pymes</router-link>
                <router-link to="/seguros-venta-y-asesoria-empresas" class="footer-link">Para empresas y corporativos</router-link>
                <!-- <router-link to="/administracion-de-riesgos" class="footer-link">Administración de riesgos</router-link> -->
            </div>
            <div class="col-lg-3 text-center text-lg-left mt-5 m-md-0">
                <h3>RMZ BLOG</h3>
                <hr>
                <a href="https://blog.rmzasesores.com" class="footer-link">Últimas entradas</a>
            </div>
            <div class="col-lg-3 text-center text-lg-left">
                <router-link to="/">
                    <img src="@/assets/images/logo-RMZ-Asesores-blanco.svg" width="210" height="60" class="mb-3 logo-footer">
                </router-link>
                <div class="row my-3 align-items-center footer-chico">
                    <div class="col-2">
                        <img src="@/assets/images/footer-icono-direccion.svg" width="40" height="40">
                    </div>
                    <div class="col-10">
                        <span class="domicilio align-middle">Perla 2564, Col. Verde Valle<br />
                        C.P.44550, Guadalajara, Jal.</span>
                    </div>
                </div>
                <div class="row align-items-center footer-chico">
                    <div class="col-2">
                        <img src="@/assets/images/footer-icono-tel.svg" width="40" height="40">
                    </div>
                    <div class="col-10">
                        <span class="tel align-middle"><a href="tel:+523335633993" class="blanco">+52 333563-3993</a></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-7">
                <div class="copy"><strong>© RMZ Asesores</strong> Todos los derechos reservados, <router-link to="/informacion-legal">Información legal</router-link>, <router-link to="/aviso-de-privacidad">Aviso de privacidad</router-link>, <br class="d-none d-md-block"/><router-link to="/cookies">Uso de las Cookies</router-link></div>
            </div>
        </div>
      </div>
    </footer>
    <div id="cookies" class="cookies row m-0 py-4" v-if="$store.getters.cookies < 1">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-9 text-right">
                    <a href="#" class="blanco" @click="$store.commit('aceptaCookiesTemp')"><img src="@/assets/images/x.svg" /></a>
                </div>
                <div class="col-md-7 pt-3">
                    <h5>Tu privacidad es importante para nosotros</h5>
                    <p>Utilizamos cookies para mejorar tu experiencia y nuestros servicios. Si continuas navegando, consideramos que aceptas su uso. Visita nuestra <router-link to="/aviso-de-privacidad">política de privacidad</router-link>, <router-link to="/informacion-legal">aviso legal</router-link> y <router-link to="/cookies">uso de cookies</router-link>.</p>
                </div>
                <div class="col-md-2 text-center pt-3">
                    <button class="btn btn-outline-primary" @click="aceptaCookies">ACEPTO</button>
                </div>
            </div>
        </div>
    </div>
      <div class="whatsapp-flota">
        <a href="https://wa.me/523310735383?text=Web rmzasesores.com: " class="d-block d-md-none"><img src="@/assets/images/envianos-un-whatsapp.png" /></a>
        <a href="https://web.whatsapp.com/send?phone=523310735383?text=Web rmzasesores.com: " class="d-none d-md-block"><img src="@/assets/images/envianos-un-whatsapp.png" /></a>
      </div>
      <div class="irarriba">
          <a href="#" v-scroll-to="'body'"><img src="@/assets/images/arriba.png" /></a>
      </div>
  </div>
</template>
<style>
/***********************************************************************
    General
************************************************************************/
body {
    font-family: 'Poppins', sans-serif;
}
.cierraMenu {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1000;
}
a.blanco img {
    width: 15px;
}
button.btn-outline-primary {
    color: #08028A;
    border: 3px solid #08028A;
    padding: 5px 30px;
    font-weight: 600;
    border-radius: 0;
}
button.btn-outline-primary:hover {
    background: #08028A;
    border: 3px solid #08028A;
}
.cookies {
    background: #00C4FF;
    color: #FFF;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1000000;
    transition-property: all;
	transition-duration: .5s;
	transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.cookies a {
    color: #FFF;
    text-decoration: underline;
    font-weight: 800;
}
.cookies h5 {
    font-size: 18px;
    font-weight: 700;
}
.cookies p {
    font-size: 12px;
}
.dropdown-toggle::after {
    content: url(../src/assets/images/flechadropdownmenu.svg);
    display: inline-block;
    margin-left: .655em;
    vertical-align: 0em;
    border-top: none;
    border-right: none;
    border-bottom: none;;
    border-left: none;
    width: 15px;
}
.contGeneral {
    height: 700px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom center;
    position: relative;
}
.blanco {
    color: #FFF;
}
.blanco:hover {
    color: #FFF;
}
.scrollDown {
    position: absolute;
    margin: -50px auto 0 auto;
    width: 100%;
    text-align: center;
}
.scrollDown img {
    width: 25px;
}
.whatsapp-flota {
    position: fixed;
    z-index: 1000;
    bottom: -10px;
    right: 0;
}
.whatsapp-flota img {
    width: 250px;
}
.irarriba {
    position: fixed;
    z-index: 1000;
    bottom: 2px;
    left: 10px;
    display: none;
}
.irarriba img {
    width: 60px;
}
/***********************************************************************
    header
************************************************************************/
header {
    padding: 30px 0;
}
#tel {
    border: 3px solid #00C4FF;
    color: #00C4FF;
    padding: 2px 10px;
    font-weight: bold;
    cursor: pointer;
}
#tel:hover {
    background: #00C4FF;
    color: #FFF;
}
#tel a {
    color: #00C4FF;
    text-decoration: none;
}
#tel:hover a {
    color: #FFF;
}
#tel:hover a:hover {
    color: #FFF;
}
/***********************************************************************
    Main
************************************************************************/
main > .container {
  padding: 60px 15px 0;
}
.container-fluid {
    background: url(../src/assets/images/background-pattern01.png);
    background-size: contain;
    background-repeat: repeat-y
}
.container-fluid.estira {
    background-size: cover;
}
/***********************************************************************
    Section comunicacion
************************************************************************/
.comunicacion {
    background: #08028A;
    color: #FFF;
    font-size: 26px;
    font-weight: 700;
    padding: 150px 0 240px 0;
    overflow: hidden;
    position: relative;
}
.comunicacion .container {
    position: relative;
    z-index: 10;
}
.comunicacion .fondo {
    width: 80%;
    height: auto;
    opacity:.2;
    position: absolute;
    top: -20px;
    left: -40px;
}
.comunicacion .fondo2 {
    height: 50%;
    width: auto;
    opacity:.2;
    position: absolute;
    bottom: -20px;
    right: -20px;
}
.comunicacion .bordes {
    border-left: 2px solid #00C4FF;
    border-right: 2px solid #00C4FF;
}
.comunicacion-titulo {
    margin-bottom: 25px;
}
.comunicacion h2 {
    font-size: 35px;
    font-weight: 300;
    margin-bottom: 60px;
}
.comunicacion .email a {
    color: #00C4FF;
}
.comunicacion .tel {
    border: 4px solid #00C4FF;
    color: #00C4FF;
    width: fit-content;
    padding: 5px 25px;
    cursor: pointer;
}
.comunicacion .tel a {
    color: #00C4FF;
}
.comunicacion .tel:hover {
    background: #00C4FF;
}
.comunicacion .tel:hover a {
    color: #FFF;
}
.comunicacion .tel a:hover {
    color: #FFF;
    text-decoration: none;
}
.comunicacion hr {
    width: 40px;
    border: 3px solid #00C4FF;
    text-align:left;
    margin-top: 0;
    margin-bottom: 10px;
}
/***********************************************************************
    Síguenos
************************************************************************/
.siguenos {
    position: relative;
}
.siguenos .bloque-azul {
    padding: 30px 0;
    background:#00C4FF;
    color: #000;
    position: absolute;
    top: -90px;
    /*-moz-box-shadow: 12px 12px 0 #1900FF;
    -webkit-box-shadow: 12px 12px 0 #1900FF;
    box-shadow: 12px 12px 0 #1900FF;*/
}
.siguenos .bloque-azul h3 {
    font-weight: 700;
    font-size: 24px;
}
.siguenos img {
    width: 40px;
    margin: 40px 40px 0 40px;
}
/***********************************************************************
    Footer
************************************************************************/
.footer {
  background-color: #000;
  color: #FFF;
}
.footer h3 {
    font-size: 16px;
    font-weight: 600;
}
.footer .container {
  padding-right: 15px;
  padding-left: 15px;
}
.separa {
  padding-top: 190px;
}
.footer .domicilio {
    font-size: 14px;
}
.footer hr {
    width: 30px;
    border: 2px solid #3A14FF;
    text-align:left;
    margin-left:0;
    margin-top: 0;
    margin-bottom: 30px;
}
.footer .tel {
    font-size: 22px;
    font-weight: 600;
}
.footer-link {
    color: #FFF;
    display: block;
    text-decoration: underline;
    font-size: 12px;
    margin: 15px 0;
}
.footer .copy {
    font-size: 12px;
    border: 2px solid #3A14FF;
    padding: 10px 20px;
    width: 100%;
    text-align: center;
    margin-top: 50px;
}
.footer .copy a {
    color: #FFF;
    text-decoration: underline;
}
.nav-item {
    padding: 0 12px;
}
.nav-item a {
    color: #FFF !important;
}
.nav-item a:hover {
    color: #00C4FF !important;
}
.nav-item a.dropdown-item {
    color: #212529 !important;
}
header.blanco, header.blancoFijo {
    background: #FFF;
}
header.blanco .nav-link, header.blancoFijo .nav-link {
    color: #000 !important;
}
header.blanco #tel, header.blancoFijo #tel {
    border: 3px solid #1B02FF;
    color: #1B02FF;
    padding: 2px 10px;
    font-weight: bold;
    cursor: pointer;
}
#header.blanco #tel:hover, header.blancoFijo #tel:hover {
    background: #1B02FF;
    color: #FFF;
}
#header.blanco #tel a, header.blancoFijo #tel a {
    color: #1B02FF;
    text-decoration: none;
}
#header.blanco #tel:hover a, #header.blancoFijo #tel:hover a {
    color: #FFF;
}
#header.blanco #tel:hover a:hover, #header.blancoFijo #tel:hover a:hover {
    color: #FFF;
}
.container-fluid .aviso {
    background: #FFF;
}
.dropdown-menu {
    padding: 30px 0;
}
.dropdown-menu {
    top: 92px !important;
    border: none !important;
    border-radius: 0 !important;
    background: #F2F2F2;
    z-index: 1000000000000;
}
.nav-item a.dropdown-item {
    color: #08028A !important;
    font-weight: 600;
    font-size: 14px;
    padding: 10px 30px;
}
.barraGris {
    background: #F2F2F2;
    height: 225px;
    position: absolute;
    z-index: 10000;
    top: 146px;
    width: 100%;
}
.navbar-dark .navbar-toggler {
    border: none;
}
.mideMenos {
    height: 450px;
}
.mideMas {
    /*height: 900px;*/
}
@media only screen and (max-width: 1023px){
    .azulTel {
        margin-top: 40px;
        background: #08028A;
        color: #FFF;
        font-size: 22px;
        font-weight: 700;
        padding: 20px 0 35px 0;
        overflow: hidden;
        position: relative;
        background-image: url(../src/assets/images/body-background-textura04.svg);
    }
    .azulTel h2 {
        font-size: 20px;
        margin-bottom: 16px;
    }
    .azulTel .tel {
        border: 4px solid #00C4FF;
        color: #00C4FF;
        width: fit-content;
        padding: 5px 25px;
        cursor: pointer;
    }
    .azulTel .tel a {
        color: #00C4FF;
    }
    .azulTel .tel:hover {
        background: #00C4FF;
    }
    .azulTel .tel:hover a {
        color: #FFF;
    }
    .azulTel .tel a:hover {
        color: #FFF;
        text-decoration: none;
    }
    .azulTel hr {
        width: 40px;
        border: 3px solid #00C4FF;
        text-align:left;
        margin-top: 0;
        margin-bottom: 10px;
    }
    .navbar-dark .navbar-toggler-icon {
        background-image: url(../src/assets/images/menu.svg);
    }
    .navbar-dark .navbar-toggler-icon2 {
        background-image: url(../src/assets/images/x_black.svg);
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        content: "";
        background-size: 100% 100%;
    }
    .navbar {
        padding: 0;
    }
    .navbar-brand {
        margin: 20px;
    }
    .navbar-toggler {
        margin: 20px;
        border: none;
    }
    .navbar-toggler:focus {
        border: none;
        outline: none;
    }
    #navbarCollapse {
        margin: 20px 0 !important;
    }
    header.blanco {
        position: absolute;
        z-index: 1000000;
        width: 100%;
        padding-bottom: 0;
    }
    .barraGris {
        background: transparent;
        display: none;
    }
    .container-fluid {
        background: url(../src/assets/images/background-pattern-01-mobile.png);
        background-size: contain;
        background-repeat: repeat-y
    }
    .navbar-nav .dropdown-menu .show {
    }
    .nav-item {
        padding: 0;
        margin:  0;
    }
    a.nav-link {
        padding: 10px 30px !important;
    }
    .dropdown-menu {
        padding: 10px 0;
    }
}
@media only screen and (max-width: 990px){
    .footer {
        padding-top: 70px !important;
        padding-bottom: 70px !important;
    }
    .footer-chico {
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
    }
    .footer hr {
        text-align: center;
        margin-left: auto;
    }
    .comunicacion {
        font-size: 22px;
    }
    .logo-footer {
        margin-top: 70px;
    }
    .siguenos {
        width: 84%;
        margin: 0 auto;
    }
    .comunicacion .bordes {
        border: none;
    }
    .siguenos img {
        width: 40px;
        margin: 20px 20px 40px 20px;
    }
}
@media only screen and (min-width:990px) and (max-width: 1024px){
    .footer .tel {
        font-size: 19px;
    }
}
</style>
<script>
import $ from 'jquery'
export default {
    data(){
        return {
            logobco: true,
            muestraMenu: true,
            flotante: false,
        }
    },
    mounted: function(){
        this.$store.commit('mideMenos', false);
        this.$store.commit('mideMas', true);
        this.$store.commit('muestraCookies');
        var anio = new Date();
        anio = anio.getFullYear();
        this.$store.commit('anio', anio);
        var este = this;
        /*$('.nav-item').mouseover(function(){
            $('header').addClass('blanco');
            este.logobco = false;
        }).mouseout(function(){
            $('header').removeClass('blanco');
            este.logobco = true;
        });*/
        $('a.dropdown-toggle').click(function(){
            if($('header').hasClass('blancoFijo')){
                $('header').removeClass('blancoFijo');
                $('.barraGris').hide();
                if(!$('header').hasClass('blanco')){
                    este.logobco = true;
                }
            } else {
                $('header').addClass('blancoFijo');
                este.logobco = false;
                $('.barraGris').show();
            }
        });
        $('a.dropdown-item').click(function(){
            if($('header').hasClass('blancoFijo')){
                $('header').removeClass('blancoFijo');
                $('.barraGris').hide();
                if(!$('header').hasClass('blanco')){
                    este.logobco = true;
                }
            } else {
                $('header').addClass('blancoFijo');
                este.logobco = false;
                $('.barraGris').show();
            }
        });
        $('button.navbar-toggler').click(function(){
            if($('header').hasClass('blanco')){
                $('header').removeClass('blanco');
                $('header').removeClass('blancoFijo');
                este.muestraMenu = true;
                este.logobco = true;
            } else {
                $('header').addClass('blanco');
                este.muestraMenu = false;
                este.logobco = false;
            }
        });
        $('.blanco, header.blancoFijo').click(function(){
            console.log('ENTRO');
        });
        //$('main, home, .contenido, .navbar-brand, .scrollDown, .barraGris, #tel, .nav-link.cierra, .dropdown-item').click(function(){
        $('.dropdown-toggle').click(function(){
            console.log('BAJA');
            este.flotante = true;
        });
        $('main, .navbar-toggler-icon2, .cierraMenu, home, .contenido, .navbar-brand, .scrollDown, .barraGris, #tel, .nav-link.cierra, .dropdown-item, .azulTel .tel a').click(function(){
            $('header').removeClass('blancoFijo');
            $('header').removeClass('blanco');
            $('.barraGris').hide();
            este.logobco = true;
            este.muestraMenu = true;
            este.flotante = false;
            $('.navbar-toggler').addClass('collapsed');
            $('#navbarCollapse').removeClass('show').css('height', '0');
        });
        $(document).scroll(function() {
          var y = $(this).scrollTop();
          if (y > 800) {
            $('.irarriba').fadeIn();
          } else {
            $('.irarriba').fadeOut();
          }
        });
    },
    methods: {
        aceptaCookies: function(){
            localStorage.setItem('cookies', 1);
            this.$store.commit('muestraCookies');
        },
        ocultaMenu: function(){
            var este = this;
            $('header').removeClass('blancoFijo');
            $('header').removeClass('blanco');
            $('.barraGris').hide();
            este.logobco = true;
            este.muestraMenu = true;
            este.flotante = false;
            $('.navbar-toggler').addClass('collapsed');
            $('#navbarCollapse').removeClass('show').css('height', '0');
        }
    }
}
</script>
